import styled from 'styled-components';

import { mediaConfined } from '@xing-com/layout-tokens';
import {
  SkeletonBodyCopy,
  SkeletonProfileImage,
  SkeletonButton,
} from '@xing-com/skeleton';
import {
  cornerRadiusL,
  spaceL,
  spaceM,
  spaceXL,
  spaceXS,
  spaceS,
  scale005,
  scale230,
  xdlColorBorder,
} from '@xing-com/tokens';
import { Row } from '@xing-com/xing-grid';

const RecruitersRecommendationsSkeleton = styled.div`
  display: flex;
  flex-direction: row;
`;

const RecruitersRecommendationsSkeletonProfileImageHandled = styled(
  SkeletonProfileImage
)`
  height: 100%;
  margin-bottom: ${spaceL};
  width: 100%;
`;

const RecruitersRecommendationsSkeletonContainerHandheld = styled.div`
  padding: ${spaceXS} ${spaceXS} ${spaceXL};
`;

const RecruitersRecommendationsCardSkeletonBodyCopy = styled(SkeletonBodyCopy)`
  margin-bottom: ${spaceS};
`;

const RecruitersRecommendationsButton = styled(SkeletonButton)`
  margin-top: ${spaceM};
  width: ${scale230};

  @media ${mediaConfined} {
    width: auto;
  }
`;

const RecruitersRecommendationsCardContainer = styled.div`
  border: ${scale005} solid ${xdlColorBorder};
  border-radius: ${cornerRadiusL};
  gap: ${spaceXL};
  margin-bottom: ${spaceXL};
  padding: ${spaceXL};
  width: auto;
`;

const RecruitersRecommendationsSkeletonProfileImageBigScreen = styled(
  SkeletonProfileImage
)`
  margin-bottom: ${spaceL};
`;

const RowContainer = styled(Row)`
  @media ${mediaConfined} {
    width: -webkit-fill-available;
  }
`;

export const Styled = {
  RecruitersRecommendationsSkeleton,
  RecruitersRecommendationsSkeletonContainerHandheld,
  RecruitersRecommendationsSkeletonProfileImageHandled,
  RecruitersRecommendationsCardSkeletonBodyCopy,
  RecruitersRecommendationsButton,
  RecruitersRecommendationsCardContainer,
  RecruitersRecommendationsSkeletonProfileImageBigScreen,
  RowContainer,
};
